import React, { useState, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
// import HomeIntorVideo from "../../../Components/Modal/supplier_app/HomeIntro/HomeIntorVideo";
import HomeCategorieDetails from "../../../Components/Modal/supplier_app/HomeIntro/HomeCategorieDetails";
import LoaderSmall from "../../../Components/LoaderSmall";
import CustomerConstants from "../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";

import customerItemService from "../../../services/customer_appCommonService";
import toast from "react-hot-toast";
import { formatToTwoDigits } from "../../../common/Validations";

//Redux
import { useSelector } from "react-redux"; //useDispatch

import "./homeIntro.scss";
import AlertNotifications from "../../../Components/AlertNotifications/AlertNotifications";
import AlertTextInputModal from "../../../Components/AlertNotifications/AlertTextInputModal";

const HomeIntro = () => {
  const currentDate = new Date();
  localStorage.setItem("menu", "Home");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store
  let appData = useSelector((state) => state?.app?.info); // appData from Store

  const navigateToMainPage = (page) => {
    if (page === "QUOTATION") {
      navigate(CustomerConstants.CUSTOMER_V4_HB_QUOTATION_LIST);
    } else if (page === "JOB") {
      navigate(CustomerConstants.CUSTOMER_V4_HB_JOB_LIST);
    } else if (page === "ESTIMATE") {
      navigate(CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST);
    } else if (page === "ESTIMATE") {
      navigate(CustomerConstants.CUSTOMER_V1_CUSTOMER_MASTER_LIST);
    } else if (page === "ENTRY") {
      navigate(CustomerConstants.CUSTOMER_V4_HB_ENTRY_LIST);
    } else if (page === "totalInvoiceCount") {
      navigate(CustomerConstants.CUSTOMER_V2_INVOICE_LIST);
    }
  };
  const localProducts = [
    { name: "", image: "/assets/img/halleysblue/intro_img/hab1.jpeg", alt: "hab1" },
    { name: "", image: "/assets/img/halleysblue/intro_img/hab2.jpeg", alt: "hab2" },
    { name: "", image: "/assets/img/halleysblue/intro_img/hab3.jpeg", alt: "hab3" },
    { name: "", image: "/assets/img/halleysblue/intro_img/hab5.jpeg", alt: "hab5" },
    { name: "", image: "/assets/img/halleysblue/intro_img/hab8.jpeg", alt: "hab8" },
    { name: "", image: "/assets/img/halleysblue/intro_img/hab9.jpeg", alt: "hab9" },
  ];
  // eslint-disable-next-line
  const [totalUserCount, setTotalUserCount] = useState("");
  // eslint-disable-next-line
  const [totalUserCountStatus, setTotalUserCountStatus] = useState(false);

  //quotation count
  const [getQuotationCount, setQuotationCount] = useState("");
  const [getQuotationCountStatus, setQuotationCountStatus] = useState(false);

  //job count
  const [totalJobCount, setTotalJobCount] = useState("");
  const [totalJobCountStatus, setTotalJobStatus] = useState(false);

  //esitmationCount
  const [getTotalEstimationCount, setTotalEstimationCount] = useState("");
  const [getEstimationStatus, setEstimationStatus] = useState(false);

  const [productdata, setProductdata] = useState({});

  // eslint-disable-next-line
  const [cards, setCards] = useState({});
  const [showTextModal, setShowTextModal] = useState(false);
 
  // State for the user-defined scrolling text
  const initialAlertMessages =
    appConfig?.scrollingTextInHomePage?.displayMessage || [];
  const [scrollingAlertMessages, setScrollingAlertMessages] =
    useState(initialAlertMessages);
 
  const handleShowTextModal = function () {
    setShowTextModal(true);
  };
  const handleHideTextModal = function() {
    setShowTextModal(false);
  }
 
  // Save handler
  const handleSaveAlertMessages = (newMessages) => {
    setScrollingAlertMessages(newMessages);
  };
 

  // total Job Count
  const loadTotalJobCounts = async () => {
    setTotalJobStatus(true);
    let obj = {
      queryName: "totalJobDocCount",
    };

    await customerItemService.ChartCountCardHB(obj).then((item) => {
      if (item?.status === 200) {
        // console.log(">>item",item.data)
        setTotalJobCount(item?.count);

        // loadOrderCompletedCount(item.data);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setTotalJobStatus(false);
  };

  // loadConfirmedDispatchCount
  const loadEstimationCount = async () => {
    setEstimationStatus(true);
    let obj = {
      queryName: "totalEstimationCount",
    };

    await customerItemService.ChartCountCardHB(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setTotalEstimationCount(item?.count);
      } else {
        toast.error(item?.message || "Please try again for Total PO Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setEstimationStatus(false);
  };

  // loadCustomerCount
  const loadQuotationCount = async () => {
    setQuotationCountStatus(true);
    let obj = {
      queryName: "totalQuotationDocCount",
    };

    await customerItemService.ChartCountCardHB(obj).then((item) => {
      // console.log(">> Details res!", item);
      if (item?.status === 200) {
        setQuotationCount(item?.count);
      } else {
        toast.error(item?.message || "Please try again for Total User Count", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setQuotationCountStatus(false);
  };

  useEffect(() => {
    loadTotalJobCounts(); // job count
    loadEstimationCount(); //estimation count
    loadQuotationCount(); //quotation count
    loadEnquiryCount(); // for enquiry entry count 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setProductdata(appConfig?.homeIntro);
    setCards(appConfig?.homeIntro?.cards);
    setProductdata({
      products: localProducts,
      mainTitle: "Our Projects",
      subTitle: "Projects :1,200+ Clients :1,000+ Built Area : 2.2cr sq. ft.",
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appConfig]);

  // Format the date (optional)
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const [getCategoryDetail, setCategoryDetail] = useState(false);
  // eslint-disable-next-line
  const [hideItem, setHideItem] = useState(false);
  // for enquiry and entry count 
    const [getEnquiryCount, setEnquiryCount] = useState("");
  

  // eslint-disable-next-line no-unused-vars
  const categoryDetailShow = () => {
    // setCategoryDetail(true);
  };

  const categoryDetailHide = () => {
    setCategoryDetail(false);
  };

  useEffect(() => {
    const userRole = userData?.roles?.[0]?.roleId || null;

    if (userRole === "CUSTOMER") {
      setHideItem(true);
    } else {
      setHideItem(false);
    }
    // console.log(">> userRole", userRole);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  // for enquiry count 
  const loadEnquiryCount = async () => {
      setEstimationStatus(true);
      let obj = {
        queryName: "Get_ENQUIRY_LIST",
        // status: "Estimation Pending",
      };
  
      try {
        const item = await customerItemService.generateCustomerQuery(obj);
  
        if (item?.status === 200) {
          const count = item?.total || 0;
          setEnquiryCount(count);
        } else {
          toast.error(
            item?.message ||
              "Please try again for Total Estimation Pending Count",
            {
              duration: 4000,
              position: "top-right",
            }
          );
        }
      } catch (err) {
        toast.error("Something went wrong", {
          duration: 3000,
          position: "top-right",
        });
      }
  
      setEstimationStatus(false);
    };

  const ProductSection = ({ data }) => {
    return (
      <Row className="homeintroposter">
        <Col
          xs={12}
          md={12}
          lg={12}
          className="postertext d-flex justify-content-center align-items-center flex-column mb-4"
        >
          <p className="fw-bold ms-2 fs-3">{data?.mainTitle}</p>
          <div className="smarthub">
            <p className="fs-5 fw-bold ms-2">{data?.subTitle}</p>
          </div>
        </Col>

        {data?.products?.map((product, index) => (
          <Col
            key={index}
            xs={12}
            md={2}
            lg={2}
            className="d-flex flex-column align-items-center p-2"
          >
            <div className="image-box d-flex justify-content-center align-items-center">
              <img
                className="img-fluid"
                src={product.image}
                alt={product.alt}
              />
            </div>
            <p className="fs-5 fw-bold m-0">{product.name}</p>
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <main className="dashboard main customer" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row className="home-intro">
              <Col xs={12} md={12} lg={12} className="headers p-2 mb-2">
                <Row>
                  <Col xs={12} md={2} lg={2}>
                    <div className="welcome">
                      <p>Welcome to</p>
                      <span>{appData?.defaultAppCode || ""} PORTAL</span>
                    </div>
                  </Col>
                  <Col
                    xs={12}
                    md={8}
                    lg={8}
                    className="d-flex justify-content-center"
                  >
                    <div className="d-flex justify-content-start align-times-end">
                      {/* {appConfig?.customerLogo1 && (
                        <img
                          className="img-fluid introCustomerlogo"
                          src={appConfig?.customerLogo1}
                          alt="logo1"
                        />
                      )} */}
                      <img
                        className="img-fluid introCustomerlogo"
                        src="/assets/img/HB/halleysblue.jpeg"
                        alt="logo1"
                      />
                      <p className="fw-bold ms-2 fs-2">
                        {appConfig?.customerName}
                      </p>
                      {appConfig?.customerLogo2 && (
                        <img
                          className="img-fluid"
                          src={appConfig?.customerLogo2}
                          alt="logo2"
                        />
                      )}
                      {/* <img
                          className="img-fluid"
                          src={appConfig?.customerLogo2}
                          alt="logo2"
                        /> */}
                    </div>
                  </Col>
                  <Col xs={12} md={2} lg={2}>
                    <div className="date commTopButtonRightLeftPadding">
                      {/* <p>Today Date:</p> */}
                      <InputField
                        className="inputBox"
                        label=""
                        name="Fuels"
                        id="Fuels"
                        placeholder=""
                        // type="date"
                        value={formattedDate}
                        // onChange={onInputChange}
                        disabled={true}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col xs={12} md={12} lg={12} className="card mb-2">
                {/* <p className="title p-2 mb-0">Overview</p> */}

                <div className="row">
                  {/* Entry */}
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card entry-card">
                      <div className="card-body">
                        <h5 className="card-title">
                          Entry/Enquiry
                          {/* <span>| </span> */}
                        </h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi-plus-circle"></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={getEstimationStatus} />
                            <h6>
                                                        {!getEstimationStatus
                                                          ? formatToTwoDigits(getEnquiryCount || 0)
                                                          : ""}
                                                      </h6>
                            {/* <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span> */}
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() => navigateToMainPage("ENTRY")}
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Job */}
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card revenue-card">
                      <div className="card-body">
                        <h5 className="card-title">
                          Job
                          {/* <span>| This Year</span> */}
                        </h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-person-workspace "></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={totalJobCountStatus} />
                            <h6>
                              {!totalJobCountStatus
                                ? formatToTwoDigits(totalJobCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span> */}
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() => navigateToMainPage("JOB")}
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
 
                  {/* Quotation */}
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card sales-card">
                      <div className="card-body">
                        <h5 className="card-title">
                          Quotation
                          {/* <span>| This Year</span> */}
                        </h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-file-earmark-text"></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={getQuotationCountStatus} />
                            <h6>
                              {!getQuotationCountStatus
                                ? formatToTwoDigits(getQuotationCount || 0)
                                : ""}
                            </h6>
                            {/* <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span> */}
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() => navigateToMainPage("QUOTATION")}
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Estimate */}
                  <div className="col-lg-3 commTopButtonRightLeftPadding">
                    <div className="card info-card customers-card">
                      <div className="card-body">
                        <h5 className="card-title">
                          Estimation
                          {/* <span>| This Year</span> */}
                        </h5>

                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-calculator"></i>
                          </div>
                          <div className="ps-3">
                            <LoaderSmall isLoading={getEstimationStatus} />
                            <h6>
                              {!getEstimationStatus
                                ? formatToTwoDigits(
                                    getTotalEstimationCount || 0
                                  )
                                : ""}
                            </h6>
                            {/* <span className="text-muted small pt-2 ps-1">
                              Total Count
                            </span> */}
                            <span
                              className="text-muted small pt-2 ps-1"
                              onClick={() => navigateToMainPage("ESTIMATE")}
                            >
                              <i className="bi bi-arrow-right-square-fill dashboard-navigate-icon"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                 

                  
                </div>
              </Col>

              {/* Scrolling Message */}
              {/* <Row className="homeintroposter my-2">
                <Col xs={12} md={12} lg={12}>
                  {appConfig?.scrollingTextInHomePage?.enabled === true && (
                    <>
                      <AlertNotifications
                        message={
                          appConfig?.scrollingTextInHomePage?.displayMessage
                        }
                      />
                    </>
                  )}
                </Col>
              </Row> */}
              <Row className="homeintroposter my-2">
                <Col xs={12} md={12} lg={12}>
                  <div className="flex justify-end mb-2">
                    <Button
                      onClick={handleShowTextModal}
                      className="py-1 px-3 text-sm font-medium rounded shadow hover:shadow-md transition duration-150 ease-in-out"
                    >
                      <i className="bi bi-pencil-fill"></i>
                    </Button>
                  </div>
                  {appConfig?.scrollingTextInHomePage?.enabled === true && (
                    <>
                      <AlertNotifications
                        // message={
                        //   appConfig?.scrollingTextInHomePage?.displayMessage
                        // }
                        message={scrollingAlertMessages}
                      />
                    </>
                  )}
                </Col>
              </Row>
 
              {/* Scrolling message end */}

              <Col xs={12} md={12} lg={12} className="mb-2">
                <ProductSection data={productdata} />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* <HomeIntorVideo show={getIntroVideo} onHide={introVideoHide} videopath={getVideoPath} /> */}
      <HomeCategorieDetails
        show={getCategoryDetail}
        onHide={categoryDetailHide}
      />
      <AlertTextInputModal
        show={showTextModal}
        onHide={handleHideTextModal}
        currentMessages={scrollingAlertMessages}
        onSave={handleSaveAlertMessages}
      />
    </main>
  );
};
export default HomeIntro;
